<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>认定管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div class="search-line clearfix">
          <input
            type="text"
            placeholder="项目名称"
            class="s-input separate"
            v-model="queryInfo.title"
            autocomplete="off"
          />
          <select
            class="s-select separate"
            v-model="queryInfo.auth_year"
          >
            <option value="">请选择获奖年份</option>
            <option
              v-for="(item,index) in yearData"
              :key="index"
              :value="item"
            >{{ item }}</option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.auth_exp_level"
          >
            <option value="">请选择获奖等级</option>
            <option
              :value="key"
              v-for="(val, key) in authExpLevelData"
              :key="key"
            >{{ val }}</option>
          </select>

          <input
            type="button"
            value="筛选"
            class="s-btn"
            @click="pageCallback(1)"
          />
        </div>
        <hr />
        <div class="search-line clearfix">

          <div
            class="import-btn"
            id="batchUpload"
            @click="showUploadWindow"
          >
            导入
          </div>
        </div>
      </div>
      <div id="list">
        <table v-if="tableData.length > 0">
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">项目名称</th>
              <th class="itemStatus">学校</th>
              <th class="itemStatus">院系</th>
              <th class="itemStatus">负责人</th>
              <th class="itemStatus">获奖年份</th>
              <th class="itemStatus">获奖等级</th>
              <th
                class="action"
                width="130"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in tableData"
              :key="item.id"
            >
              <td class="itemStatus">{{ item.title }}</td>
              <td class="itemStatus">{{item.school_title?item.school_title:'--'}}</td>
              <td class="itemStatus">{{item.academy_title?item.academy_title:'--'}}</td>
              <td class="itemStatus">{{item.master_name}}</td>
              <td class="itemStatus">{{item.auth_year}}</td>
              <td class="itemStatus">{{authExpLevelData[item.auth_exp_level]}}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="querySingle(item.id)"
                >设置获奖情况</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur="pageInfo.page"
        :all="pageInfo.all"
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
      <!-- 用户添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">设置获奖情况</div>
          <div class="form_content">
            <form id="itemForm">

              <div class="item">
                <span class="label">获奖年份:</span>
                <select v-model="formInfo.auth_year">
                  <option
                    v-for="(item,index) in yearData"
                    :key="index"
                    :value="item"
                  >{{ item }}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"> <i class="require">*</i>获奖等级: </span>
                <select v-model="formInfo.auth_exp_level">
                  <option
                    :value="key"
                    v-for="(val, key) in authExpLevelData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        class="form_overlay"
        :style="classShowUploadWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">批量上传</div>
          <div class="form_content">
            <form id="uploadForm">
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require"></i>模版创建规则:
                </span>
                <div class="item-box divLabel gray">
                  <div class="normal-width">
                    <p>1. 文件格式为常用的Excel(.xls)文件；</p>
                    <p>
                      2.
                      填写导入数据时，需先删除导入模版中首行以下所有说明示例数据；
                    </p>
                    <p>
                      3.
                      导入的数据总条数不得超过2000条，如超过，则需分多次导入；
                    </p>
                    <p>
                      4.
                      获奖等级分为：国家级、省级、校级、未定级；
                    </p>
                  </div>
                </div>
                <div class="clear"></div>
                <div class="attachment">
                  <a
                    href="/static/upload_template/batch_upload_affirm_demo.xls"
                    download="batch_upload_affirm_demo.xls"
                    target="_blank"
                  >模版下载</a>
                </div>
              </div>
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require">*</i>Excel文件:
                </span>
                <div
                  class="item-box"
                  style="margin-left: 130px"
                >
                  <input
                    v-model="uploadedCsv"
                    disabled
                    type="text"
                    id="fileUrl"
                    style="width: 225px"
                  />
                  <span
                    class="button"
                    style="position: relative; top: 0px; left: 0px"
                  >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    />
                  </span>
                </div>
                <div class="clear"></div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              style="width: 30px"
              class="button close"
              id="form_upload_close"
              @click="hideUploadWindow"
            >取消</a>
            <a
              href="javascript:;"
              style="width: 30px"
              class="button"
              id="form_upload_submit"
              @click="submitCsv"
            >提交</a>
          </div>
        </div>
      </div>
      <!-- 导入提示弹窗 -->
      <div
        id="dialog_overlay"
        :style="classShowProcessWindow"
      >
        <div id="dialog_bg"></div>
        <div
          id="dialog_panel"
          ref="refErrorList"
          style="transform: translate(-50%, -50%);"
        >
          <div id="dialog_panel_bg"></div>
          <div id="dialog_title">提示</div>
          <div id="dialog_content">
            ({{ curCsvIndex }} / {{ uploadedCscData.length }})
            <span style="color: #219d2b">
              {{ ' ' + csvFinishText }}
            </span>
          </div>
          <div id="dialog_content2">
            <ul>
              <li
                v-for="(item, index) in errorList"
                v-bind:key="index"
              >
                <span :class="item.code == 1 ? 'success' : 'fail'">{{ item.text }}</span>
              </li>
            </ul>

          </div>
          <div id="dialog_control">
            <a
              href="javascript:void(0)"
              id="dialog_ok"
              class="button col2"
              @click="classShowProcessWindow={}"
              :style="isFinishUpsert ? 'display: inline-block' : 'display:none'"
            >确认</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Affirm',
  components: {
    Pagination
  },
  data() {
    return {
      ckUser: [],
      classShowAddWindow: {},
      classShowUploadWindow: {},
      tableData: [],

      queryInfo: {
        page: 1,
        size: 10,
        auth_status: 1,
        title: '',
        auth_year: '',
        auth_exp_level: ''
      },
      formInfo: {
        auth_year: '',
        auth_exp_level: ''
      },
      tableDataCount: 0,
      uploadedCsv: '',
      uploadedCsvName: '',
      uploadedCscData: [],
      isFinishUpsert: false,
      curCsvIndex: 0,
      csvFinishText: '',
      errorList: [],
      classShowProcessWindow: {}
    }
  },
  methods: {

    async search() {
      await this.$http.get('/experiment_list/', {
        params: this.queryInfo
      }).then((data) => {
        if (data.code === '200') {
          this.tableData = data.data.results
          this.tableDataCount = data.data.count
        } else {
          this.$layer.msg('获取实验信息失败！')
        }
      }).catch((error) => {
        console.log(error)
      })
    },

    async xlsChange() {
      const uploadUrl = '/files/' + this.$refs.xlsFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.xlsFile.files[0]).then((data) => {
        this.uploadedCsv = data
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    // 打开用户添加/编辑弹窗
    showAddWindow(value) {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭用户添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    // 保存
    async saveInfo() {
      if (!this.formInfo.auth_exp_level) {
        this.$parent.showMsg('请选择认定级别!')
        return false
      }
      if (!this.formInfo.auth_year) {
        this.$parent.showMsg('请选择认定年份!')
        return false
      }

      if (this.formInfo.id) {
        const url = '/experiment/' + this.formInfo.id + '/'

        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.search()
            this.hideAddWindow()
          } else {
            this.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      }
    },

    // 编辑时查询
    async querySingle(id) {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
      const url = '/experiment/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo.id = data.id
        this.formInfo.auth_year = data.auth_year
        this.formInfo.auth_exp_level = data.auth_exp_level
      }).catch((error) => {
        console.log(error)
      })
    },
    async submitCsv() {
      const uploadUrl = '/get_excel/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 1) {
          this.$parent.showMsg('表格中无数据！')
          return
        }
        data.splice(0, 1)
        this.uploadedCscData = data
        this.hideUploadWindow()
        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.uploadedCsv = ''
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.search()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]

      // region 数据检查开始
      if (row[0].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[0] + ']' + '请输入ID！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[1].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '请输入项目名称！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      const url = '/experiment/' + row[0] + '/'
      let title
      await this.$http.get(url).then(async (data) => {
        title = data.title
      }).catch(async (error) => {
        console.log(error.response.data[0])
      })
      if (row[1].toString().trim() !== title) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '项目不存在！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[2].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[2] + ']' + '请输入获奖年份信息！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[3].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[3] + ']' + '请输入获奖等级！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      let level
      for (const i in this.authExpLevelData) {
        if (row[3] === this.authExpLevelData[i]) {
          level = i
        }
      }

      const profileForm = {
        auth_year: row[2],
        auth_exp_level: level,
        auth_status: 1
      }
      // endregion 数据检查结束
      const path = '/experiment/' + row[0] + '/'
      await this.$http.put(path, profileForm).then((data) => {
        this.errorList.push({ code: 1, text: '[' + row[1] + ']' + '导入成功！' })
        this.curCsvIndex++
        this.insertOne()
      }).catch((error) => {
        console.log(error)
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + error.response.data[0] })
        this.curCsvIndex++
        this.insertOne()
      })
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    },
    authExpLevelData() {
      return this.$store.state.dict_auth_exp_level
    },
    yearData() {
      const year = []
      for (let i = new Date().getFullYear(); i >= 2017; i--) {
        year.push(i)
      }
      return year
    }
  },
  async created() {
    await this.search()
  },
  async mounted() {
    // this.search()
    // if (parseInt(this.localUser.role) === 1) {
    //   this.getMajor(this.localUser.academy_id)
    //   this.formInfo.academy_id = this.localUser.academy_id
    // }
  }
}
</script>

<style scoped>
#dialog_content {
  padding: 10px;
}
#dialog_content2 {
  max-height: 200px;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}
</style>
